import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { UserRole } from '../../../models/user-role.interface';

@Component({
    selector: 'app-search-role-dialog',
    templateUrl: './search-role-dialog.component.html',
    styleUrls: ['./search-role-dialog.component.scss'],
    standalone: false
})
export class SearchRoleDialogComponent implements OnInit {
  searchingRoles: boolean = false;
  roleControl: UntypedFormControl = new UntypedFormControl();
  userRoles: UserRole[] = [];

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<SearchRoleDialogComponent>
  ) {}

  ngOnInit(): void {
    this.loadUserRoles();
  }

  loadUserRoles(): void {
    this.searchingRoles = true;
    this.http.get<UserRole[]>(environment.apiURL1 + 'resources/list-user-roles').subscribe({
      next: (response: UserRole[]) => {
        this.userRoles = response;
        this.searchingRoles = false;
      },
      error: (error) => {
        console.error('Error loading user roles:', error);
        this.searchingRoles = false;
      }
    });
  }

  confirm(): void {
    this.dialogRef.close(this.roleControl.value);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}